<template>
	<Container>
		<TopBar />
		<div class="confirmPage">
			<div class='container mainWrap'>
				<div class='orderConfirmCon'>
					<div class='oShow' v-if='desc&&list'>
						<h2 v-if='false' class="u-mntlt"><strong>選擇收貨地址 Select Delivery Address</strong></h2>
						<!--訂單確認-->
						<div class='orderwrap'>
							<h2 class="u-mntlt"><strong>確認訂單信息(Confirm Order) </strong></h2>
							<div class='m-goodstbl'>
								<div class="thead no_mobile">
									<span class="col1">産品信息(Product)</span>
									<span class="col2 ">産品點數(PV)</span>
									<span class="col3">單價(Unit Price)</span>
									<!-- <span class="col6">兌換(Redeem)</span> -->
									<span class="col4">數量(Qty)</span>
									<span class="col5">小計(Sub Total)</span>
								</div>
								<div class='m-warebox'>
									<div class='packinfo'>
										<span class='source'>
											<Icon type="location" size='16' color='#cbccce'></Icon>
											&nbsp;
											運送方式(Type of Delivery)&nbsp;&nbsp;
											<em v-if="orderNo ? desc.virtual_flag == 0 : virtual_flag == 0">單次送貨 Single Delivery</em>
											<em v-if="orderNo ? desc.virtual_flag == 1 : virtual_flag == 1">合併發貨 Group Delivery</em>
											<em v-if="orderNo ? desc.virtual_flag == 6 && !desc.proxy : virtual_flag == 6 && !desc.proxy">合併自提 Group Pickup</em>
											<em v-if="orderNo ? desc.virtual_flag == 6 && desc.proxy : virtual_flag == 6 && desc.proxy">團隊合併自提 Leader Group Pickup: {{ desc.proxy }}</em>
											<!-- <em>{{selectdesc.default_store_name}}({{(desc.store_id=="501"||selectdesc.code=="501")?'Package Deliver':'Pick up Station'}})</em> -->
										</span>
										<span class="taxfee">本次運費 Delivery Fee：HK${{desc.delivery_fee.toFixed(2)}}<b class="arr"></b></span>
									</div>

									<div class='m-goodstbl'>
										<table class='tbody'>
											<tr v-for="(products,productindex) in carlist(0)" :key="productindex" v-if="carlist(0)">
												<td class='col1'>
													<div class="td-left">
														<img class="img" src="@/assets/order/errorImg2.png" v-real-img="products.Url">
													</div>
													<div class="td-right">
														<p class="f-vama f-cb">
															<span class="name" :title="products.name">
																{{products.name}}
															</span>
														</p>
														<p class="skuline" title="規格：15m">規格：{{products.specification}}</p>
														<div class='product_detail_footer'>
															<div class='product_price'>
																<span>HK$</span>
																<span>{{products.price.toFixed(2)}}</span>
															</div>
															<div class="product_price1">
																<span>X</span>
																<span>{{products.num}}</span>
																<span>金額：HK${{products.amount.toFixed(2)}}</span>
															</div>
														</div>
													</div>
												</td>

												<td class='col2 no_mobile'>
													{{products.pv}}
												</td>
												<td class='col3 no_mobile'>
													{{products.price.toFixed(2)}}
												</td>
												<!-- <td class='col6 no_mobile'>
													{{products.point>0?products.point/products.pt:0}}
												</td> -->
												<td class="col4 no_mobile">
													{{products.num}}
												</td>
												<td class="col5 no_mobile">
													<div class="amountcol">
														<em class="amount">{{products.amount.toFixed(2)}}</em>
													</div>
												</td>
											</tr>
											<tr class='promote' v-for="(products,productindex) in carlist(1)" :key="productindex" v-if="carlist(1)">

												<td class='col1'>
													<div class="td-left">
														<img class="img" src="@/assets/order/errorImg2.png" v-real-img="products.Url">
													</div>
													<div class="td-right">
														<p class="f-vama f-cb">
															<span class="name" :title="products.name">
																{{products.name}}
															</span>

														</p>

														<p class="skuline" title="規格：15m">規格：{{products.specification}}</p>
														<p class="returninfo f-toe">
															<img src="@/assets/order/promotion.png">
															<span style="" class="">{{products.spec_name}}</span>
														</p>
														<div class='product_detail_footer'>
															<div class='product_price'>
																<span>HK$</span>
																<span>{{products.price.toFixed(2)}}</span>
															</div>
															<div class="product_price1">
																<span>X</span>
																<span>{{products.num}}</span>
																<span>金額：HK${{products.amount.toFixed(2)}}</span>
															</div>
														</div>
													</div>

												</td>
												<td class='col2 no_mobile'>
													{{isOriginalPrice?products.pv:products.pv+'/'+products.pt+'PT'}}
												</td>
												<td class='col3 no_mobile'>
													{{products.price.toFixed(2)}}
												</td>
												<!-- <td class='col6 no_mobile'>
													{{products.point>0?products.point/products.pt:0}}
												</td> -->
												<td class="col4 no_mobile">
													{{products.num}}
												</td>
												<td class="col5 no_mobile">
													<div class="amountcol">
														<em class="amount">{{products.amount.toFixed(2)}}</em>
													</div>
												</td>
											</tr>
										</table>
									</div>
									<div class='packinfo' style='border-bottom:0'>
										<span class='source'>
											<!-- <Icon type="location"  size='16' color='#cbccce'></Icon> -->
											&nbsp;
											<!-- <Checkbox>協助客戶下單</Checkbox> -->
										</span>

									</div>
								</div>
							</div>
						</div>
						<div class="order-summary">
							<div class="statistic">
								<div class="list">
									<!-- <span><em class="ftx-01">{{list.length}}</em> 件商品，産品總價(Product Total Price)：</span> -->
									<span>産品總價(Product Total Price)：</span>
									<em class="price" id="warePriceId" v="3699">HK${{desc.total_product_amount.toFixed(2)}}</em>
								</div>
								<div class="list">
									<span>産品總點數(Product Total PV)：</span>
									<em class="price" id="freightPriceId"><i class="freight-icon"></i>
										<font color="#000000"> {{desc.total_pv.toFixed(2)}}</font>
									</em>
								</div>
								<!-- <div class="list">
									<span>産品積分(Product Credits)：</span>
									<em class="price" id="freightPriceId"><i class="freight-icon"></i>
										<font color="#000000"> {{desc.ar_value.toFixed(2)}}</font>
									</em>
								</div> -->
								<div class="list" v-if="desc&&desc.ab_value>0">
									<span>賬戶餘額(Account Balance)：</span>
									<em class="price" id="freightPriceId"><i class="freight-icon"></i>
										<font color="#000000"> {{desc.ab_value.toFixed(2)}}</font>
									</em>
								</div>

								<!-- <div class="list">
									<span>兌換點數(Redeem Point)：</span>
									<em class="price" id="freightPriceId"><i class="freight-icon"></i>
										<font color="#000000"> {{desc.total_change_point.toFixed(2)}}</font>
									</em>
								</div> -->
								<div class="list" style="display:block;">
									<span>配送費/手續費(Delivery Fee/Handling Charge)：</span>
									<div class="price" id="serviceFeeId">
										<div class="mdeliveryFemv" v-if='free>0'>
											<div style="color: rgb(255, 70, 29);border-color: rgb(255, 70, 29);">
												<p style="color: rgb(255, 70, 29);">免{{free.toFixed(2)}}</p>
											</div>
										</div>
										<b class="ellipsis" :class="{add_x: free > 0, move_x:(sys_deliveryFee-free)>0}" style="width:initial;font-weight: 500;" v-text='resuldeliveryFee()'></b>
									</div>

								</div>
							</div>
						</div>
						<div class='trade-foot'>
							<div class='trade-foot-detail-com'>
								<div class='fc-price-info'>
									<span class="price-tit">應付總額(SubTotal)：</span>
									<span class="price-num">HK${{desc.pay_fee.toFixed(2)}}</span>
								</div>

								<div class="fc-consignee-info" v-if='desc.store_id=="501"||selectdesc.code=="501"'>
									<span v-if='isEdit' class='edit' @click='modifyAddress(choosedAddress)'>修改(Edit)</span>
									<span class="mr20" id="sendAddr">寄送至(Send to)： {{selectdesc.province}} {{selectdesc.city}} {{selectdesc.street}} {{selectdesc.street2}}&nbsp;&nbsp; {{selectdesc.email}}</span><br>
									<span id="sendMobile">收貨人(Receiver)：{{selectdesc.name}} {{passwordTel}}</span>
									<!-- <div class='' v-if='BHbuy'>
										<span v-if='isEdit&&BHbuy' class='edit' @click='BHshowfun'>修改(Edit)</span>
										<span>{{desc.remark||'暫未定製生日禮遇專屬文字'}}</span>
									</div> -->
								</div>
								<div class='fc-consignee-info' v-else>
									<!-- <div class='' v-if='BHbuy'>
										<span v-if='isEdit&&BHbuy' class='edit' @click='BHshowfun'>修改(Edit)</span>
										<span>{{desc.remark||'暫未定製生日禮遇專屬文字'}}</span>
									</div> -->
								</div>
							</div>
						</div>
						<p class="wy" v-if='epidemic' v-html="epidemic"></p>
						<div class='foot-button'>
							<Button :loading="goloading" type="primary" @click='confirm'>提交訂單<b>Submit Order</b></Button>
							<Button :disabled='goloading' type="primary" @click='gocart'>返回購物車<b>Return to Cart</b></Button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<editAddressView :title="editAddress.id>0?'編輯地址(Edit address)':'新增地址(New address)'" :editAddress='editAddress' :show='show' @confirm='asyncOK' @cancel='show=false' :loading='loading'></editAddressView>
		<Modal title="生日專屬禮遇" v-model="BHshow" :closable="false" :mask-closable="false">
			<div class='main-bh'>
				<p class='tip' :class='{highlight:BHerror_text}'><b>溫馨提示&nbsp;:&nbsp;</b>僅限最多6位英文字母，大小寫皆可，不可空格。例PeterZ, ZhuYQ</p>
				<Input v-model="BHtext" :class='{error:BHerror_input}' placeholder="請填寫您需要定製的生日禮遇專屬文字"></Input>
			</div>
			<div slot="footer">
				<button @click="BHscancel" type="button" class="ivu-btn ivu-btn-text ivu-btn-large"> <span>取消(cancel)</span></button>
				<button @click="BHsconfirm" type="button" class="ivu-btn ivu-btn-primary ivu-btn-large"><span>確認(confirm)</span></button>
			</div>
		</Modal>
		<orderSurvey :model="survey" :value='showSurvey' />
	</Container>
</template>
    
<script>
import { api_methods } from "@/service/loadData";
import TopBar from "@/components/common/TopBar";
import editAddressView from "@/components/order/editAddressView";
import orderSurvey from "@/components/order/orderSurvey";
import {
	systemConfigMethods,
	addressMethods,
	getImgPath
} from "@/components/common/mixin";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
export default {
	data() {
		return {
			auto: false,
			result: false,
			goloading: false,

			desc: null,
			list: null,
			selectdesc: null,
			free: 0,
			sys_deliveryFee: 0, //係統運費
			isEdit: false,

			BHshow: false,
			BHtext: null,
			BHerror_text: null,
			BHerror_input: null,
			BHbuy: false,
			epidemic: null,

			showSurvey: false,
			survey: null,
			selectCart:{},
			selfOrder:null
		};
	},
	created() {
		this.$nextTick(function() {
			// if (this.$route.query&&this.$route.query.os&&this.$route.query.orderno) {
			// 	this.SET_ORDERNN({ orderno: this.$route.query.orderno, os: this.$route.query.os });
			// }
			this.initData();
		});
	},
	mixins: [systemConfigMethods, addressMethods],
	components: {
		TopBar,
		editAddressView,
		orderSurvey
	},
	watch: {
		addresses: function(value, ovalue) {
			if (value && value.length > 0) {
				var change = value.filter(u => u.id == this.choosedAddress.id);
				if (change[0]) {
					this.CHOOSE_ADDRESS({
						address: change[0],
						index: 0
					});

					this.selectdesc["name"] = this.choosedAddress.name;
					this.selectdesc[
						"moblie_phone"
					] = this.choosedAddress.moblie_phone;
					this.selectdesc["tag_type"] = this.choosedAddress.tag_type;
					this.selectdesc["province"] = this.choosedAddress.province;
					this.selectdesc["city"] = this.choosedAddress.city;
					this.selectdesc["county"] = this.choosedAddress.county;
					this.selectdesc["town"] = this.choosedAddress.town;
					this.selectdesc["street"] = this.choosedAddress.street;
					this.selectdesc["street2"] = this.choosedAddress.street2;
					this.selectdesc["email"] = this.choosedAddress.email;
					this.initData()
				}
			}
		}
	},
	computed: {
		...mapGetters(["bogo_switch_tip", "getAccessToken", "getVipNo","getUserId"]),
		...mapState({
			sysConfig: state => state.common.sysConfig,
			choosedAddress: state => state.order.choosedAddress,
			userInfo: state => state.common.wechatUserInfo,
			forCustomer: state => state.order.forCustomer,
			cartInfo: state => state.order.cartInfo,
			orderNo: state => state.order.orderno,
			orderType: state => state.order.orderType,
			virtual_flag:state => state.order.virtual_flag,
			cartCheck:(state) => state.order.cartCheck,
			
		}),
		isOriginalPrice: function() {
			if (this.selectdesc) {
				if (this.selectdesc.customer_type.toLowerCase() == "rt") {
					return true;
				}
			}
			return false;
		},
		passwordTel: function() {
			if (
				this.selectdesc.moblie_phone &&
				this.selectdesc.moblie_phone.length >= 11
			) {
				return this.selectdesc.moblie_phone.replace(
					/(\d{3})\d{4}(\d{4})/,
					"$1****$2"
				);
			} else {
				return this.selectdesc.moblie_phone;
			}
		},
		selCartList:function(){
			var arry=[]
			var list=this.list||[]
			let cartCheck= this.selectCart||{};
			var orderNo = this.selfOrder && this.selfOrder.orderno;
			if(orderNo){
				return list
			}
			list.forEach((item,index)=>{
				if(item.product_flag==1||cartCheck[item.sku]){
					arry.push(item)
				}
			})
			return arry
		}
	},
	methods: {
		...mapActions([
			"postAddAddressAction",
			"getTipDetailAction",
			"getWechatUserInfoAction"
		]),
		...mapMutations([
			"CHOOSE_ADDRESS",
			"CLEAR_DATA",
			"SET_ORDERNN",
			"SET_CHARITABLE",
			"PAY_STATE",
			"CLEAR_CART",
			"SET_ORDERTYPE",
			'SET_SELECTMERGE',
			'SET_BALANCERECORD',
			'REDUCEALL_SELCART'
		]),
		async oepnDoubt() {
			var res = await this.getTipDetailAction(
				"Tips_OD_DeliveryDelay"
			);
			if (res && !this.isEmpty(res.Content)) {
				this.epidemic = res.Content;
			}
		},
		resuldeliveryFee() {
			var Fee = this.sys_deliveryFee - this.free;
			return Fee > 0 ? Fee.toFixed(2) : (this.sys_deliveryFee + this.desc.delivery_fee).toFixed(2);
		},
		shopCartList() {
			let newArr = new Array();
			Object.values(this.selCartList).forEach(item => {
						newArr.push({
						id: item.Id,
						name: item.name,
						packing_fee: item.packing_fee,
						price: item.price,
						pt: item.pt,
						pv: item.pv,
						point: item.point,
						amount: item.amount, //現金支付金額
						ar_value: item.ar_value, //AR支付金額
						num: item.num, //數量(個數)，point支付和 amount支付總計個數
						sku_id: item.sku_id,
						sku: item.sku,
						selected: item.selected,
						spec_code: item.spec_code,
						spec_name: item.spec_name,
						product_flag: item.product_flag,
						promo_code: item.promo_code,
						specification: item.specification,
						Url: item.Url,
						remark:item.remark
					});
			
			});
			return newArr;
		},
		gocart() {
			this.$router.push({
				path: "/order/cart"
			});
		},
		BHshowfun() {
			this.BHerror_input = false;
			this.BHtext = this.desc.remark;
			this.BHshow = true;
		},
		BHscancel() {
			//this.BHtext=''
			this.BHshow = false;
		},
		BHsconfirm() {
			if (!/^[A-Za-z]{0,6}$/.test(this.BHtext)) {
				//this.BHerror_text=true;
				this.BHerror_input = true;
				console.error("錯誤了");
				return false;
			}
			if (!this.BHtext) {
				this.BHerror_input = true;
				return false;
			}
			this.desc.remark = this.BHtext;
			this.BHshow = false;
		},
		carlist(type) {
			var model = [];
			if (type == 0) {
				model = this.selCartList.filter(u => u.product_flag != 1);
			} else {
				model = this.selCartList.filter(u => u.product_flag == 1);
			}
			if (model[0]) {
				return model;
			}
			return null;
		},
		async initData() {
			this.oepnDoubt();
			
			this.selectCart=this.cartCheck
			this.selfOrder=this.orderNo;
			var virtual_flag=0;
			var orderNo = this.selfOrder && this.selfOrder.orderno;
			console.log(orderNo)
			var os = this.selfOrder && this.selfOrder.os;
			var res = await api_methods.getProductOrder(
				this.getAccessToken,
				this.getUserId,
				orderNo,
				this.userInfo.value.binding.user_id,
				0,
				os
			);
			if (res && res.data && res.data.value) {
				var model = res.data.value;
				if (orderNo) {
					this.desc = model.desc;
					this.list = model.product;
					this.selectdesc = model.delivery;
					virtual_flag=this.desc.virtual_flag;

					// if(virtual_flag==10){
					// 	this.PAY_STATE(1);
					// 	this.$router.push({
					// 		path: "/order/payment",
					// 		query: {
					// 			orderno: this.orderNo.orderno,
					// 			os: this.orderNo.os
					// 		}
					// 	});
					// 	return false;
					// }

				} else {
					this.desc = model.desc;
					this.list = model.product;
					this.selectdesc = null;
					virtual_flag=this.virtual_flag;
					if (this.orderType == 11) {
						this.desc.lrpt_order = 11;
					}
					this.isEdit = true;
				}
				if (this.desc.remark != null&&this.desc.remark !='-1') {
					this.BHbuy = true;
				}
				//調整數據
				if (!this.selectdesc) {
					var name = null;
					var customer_type = this.userInfo.value.binding
						.customer_type;
					if (this.forCustomer) {
						name = this.forCustomer.name;
						customer_type = this.forCustomer.customer_type;
					}
					this.selectdesc = {
						default_delivery_mode_desc: this.userInfo.value.binding
							.default_delivery_mode_desc,
						default_store_name: this.userInfo.value.binding
							.default_store_name,
						default_store_nameen: this.userInfo.value.binding
							.default_store_nameen,
						code:
							this.userInfo.value.binding.default_store_id || 501,
						name: this.choosedAddress.name,
						moblie_phone: this.choosedAddress.moblie_phone,
						tag_type: this.choosedAddress.tag_type,
						province: this.choosedAddress.province,
						city: this.choosedAddress.city,
						county: this.choosedAddress.county,
						town: this.choosedAddress.town,
						street: this.choosedAddress.street,
						street2: this.choosedAddress.street2,
						email: this.choosedAddress.email,
						customer_type: customer_type,
						for_name: name,
						is_for: this.forCustomer ? 1 : 0
					};
				}
				
				if (this.selectdesc.code == "501"&&virtual_flag==0) {
					// alert(this.sysConfig.value)
					if (
						this.sysConfig &&
						this.sysConfig.value &&
						this.sysConfig.value.float_delivery_fee
					) {
						this.sys_deliveryFee = this.choosedAddress.province_id == '110000' ? Number(
							this.sysConfig.value.float_delivery_fee_hongkong
						) : Number(
							this.sysConfig.value.float_delivery_fee_macao
						);
						if(this.desc.total_product_amount < 2000){
							this.desc.delivery_fee = this.choosedAddress.province_id == '110000' ? Number(
								this.sysConfig.value.float_delivery_fee_hongkong
							) : Number(
								this.sysConfig.value.float_delivery_fee_macao
							);
						}
						this.free = this.sys_deliveryFee - this.desc.delivery_fee;
						this.desc.pay_fee =  this.desc.total_product_amount + this.desc.delivery_fee;
						console.log(this.sys_deliveryFee,this.free,this.desc.delivery_fee)
					}
				}
			}
		},
		clerSelCart(){

		},
		async confirm() {
			if (this.orderNo && this.orderNo.orderno) {
				this.PAY_STATE(1);
				this.$router.push({
					path: "/order/payment",
					query: {
						orderno: this.orderNo.orderno,
						os: this.orderNo.os
					}
				});
				return false;
			}
			this.goloading = true;
			var ll = this.shopCartList();
			var store_id = this.selectdesc.code;
			let cv = this.desc;

			var vipno = this.userInfo.value.binding.register.vip_no;
			var catalog = this.userInfo.value.binding.catalog;
			var first_order_status = this.userInfo.value.binding
				.first_order_status;
			var id_card = this.userInfo.value.binding.register.id_card;
			if (this.forCustomer) {
				vipno = this.forCustomer.vipno;
				catalog = this.forCustomer.catalog;
				first_order_status = this.forCustomer.first_order_status;
			}

			let minCart = {
				customer_id: cv.customer_id,
				vip_no: vipno,
				id_card: id_card,
				catalog: this.desc.catalog,
				first_order_status: first_order_status,
				promo_code: this.desc.promo_code,
				total_num: cv.total_num,
				total_price: cv.total_price,
				total_pv: cv.total_pv,
				total_change_point: cv.total_change_point,
				total_change_point_num: cv.total_change_point_num,
				total_product_amount: cv.total_product_amount,
				delivery_fee: cv.delivery_fee,
				service_fee: cv.service_fee,
				ar_value: cv.ar_value || 0,
				ab_value: cv.ab_value || 0,
				pay_fee: cv.pay_fee,
				lrpt_order: cv.lrpt_order,
				spec_code: cv.spec_code,
				virtual_flag:this.virtual_flag,
				ship_method: store_id,

				ship_name: this.choosedAddress.name,
				region: this.choosedAddress.province,
				city: this.choosedAddress.city,
				county: this.choosedAddress.county,
				street: this.choosedAddress.street,
				street2: this.choosedAddress.street2,
				district: this.choosedAddress.district,
				town: this.choosedAddress.town,
				zip: this.choosedAddress.zip,
				email: this.choosedAddress.email,
				wechatno: this.choosedAddress.wechatno,
				moblie_phone: this.choosedAddress.moblie_phone,

				province_id: this.choosedAddress.province_id,
				city_id: this.choosedAddress.city_id,
				county_id: this.choosedAddress.county_id,
				town_id: this.choosedAddress.town_id,
				tag_type: this.choosedAddress.tag_type,
				tag: this.choosedAddress.tag,
				address_type: this.choosedAddress.address_type,
				is_default: this.choosedAddress.is_default,
				for_name: this.selectdesc.for_name,
				customer_type: this.selectdesc.customer_type,
				default_delivery_mode_desc: this.selectdesc
					.default_delivery_mode_desc,
				default_store_name: this.selectdesc.default_store_name,
				default_store_nameen: this.selectdesc.default_store_nameen,
				code: this.selectdesc.code,
				is_result: this.desc.is_result,
				remark: this.desc.remark,
				up: "0",
				proxy: this.desc.proxy,
				detail: ll
			};
			let ret = await api_methods.saveOrder(
				this.getAccessToken,
				this.getUserId,
				minCart,
				0,
				new Date()
			);
			this.goloading = false;

			if (ret && ret.response && ret.response.code == "1") {
				var number = ret.data.value.code;
				if (ret.response.errorCode == "0100") {
					this.$Modal.error({
						title: "錯誤 (error)",
						content: ret.data.value.message,
						loading: true,
						okText: "重新加載",
						onOk: async () => {
							await this.getWechatUserInfoAction();
							this.$Modal.remove();
						}
					});
					return;
				}
				if (number != "-1") {
					var orderno = ret.data.value.orderNo;
					this.CHOOSE_ADDRESS({});
					this.CLEAR_DATA();
					this.SET_ORDERNN({ orderno: number, os: orderno });

					this.SET_CHARITABLE({ result: false, list: null });
					this.PAY_STATE(1);
					//this.CLEAR_CART();
					this.REDUCEALL_SELCART()
					this.SET_ORDERTYPE(0);
					this.SET_SELECTMERGE(0);
					//this.SET_BALANCERECORD();

					if (ret.data.value.specInfo) {
						this.survey = ret.data.value.specInfo;
						this.survey.orderno = number;
						this.survey.os = orderno;
						this.showSurvey = true;
					} else {
						this.$router.push({
							path: "/order/payment",
							query: {
								orderno: number,
								os: orderno
							}
						});
					}
				} else {
					this.$Modal.error({
						title: "錯誤 (error)",
						content: ret.data.value.message
					});
				}
			} else {
				this.$Modal.error({
					title: "錯誤 (error)",
					content: ret.response.message
				});
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/style/common";
@import "@/style/mixin";
.wy {
	color: red;
	font-weight: 800;
	padding: 10px;
	overflow: hidden;
	//float: right;
}
.mainWrap {
	background-color: white;
}
.header {
}

.content {
	margin-top: 0.3rem;
	margin-bottom: 0.1rem;
	flex: 1 0 auto;
}
.f-toe {
	overflow: hidden;
	display: block;
	word-wrap: normal;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.td-left {
	display: flex;
	flex-direction: column;
}
.mainWrap {
	//margin-top: 0.8rem;
	//width: 1090px;

	width: 78.03vw;
	margin: 40px auto;

	border-top: none;
	padding-top: 0;
	.orderConfirmCon {
		margin: 0 auto;
		color: #333;
		position: relative;
		z-index: 1;
	}
	.u-mntlt {
		display: block;
		@include fontSize($font-size-16);
		color: rgb(51, 51, 51);
		font-family: 微軟雅黑;
		height: 34px;
		line-height: 24px;
		border-bottom: 1px solid rgb(221, 221, 221);
		padding: 0px 0px 5px 0px;
		margin: 10px 0px 5px;
		background: none;
		// strong {
		// 	@include fontSize($font-size-14) !important;
		// }
		span {
			float: right;
			@include fontSize($font-size-12);
			color: #0066cc;
		}
	}
	.m-addrbox {
		margin-top: 15px;
	}
	.editAd_tb {
		* {
			box-sizing: initial;
		}
		display: table-row-group;
		vertical-align: middle;
		border-color: inherit;
		tr {
			height: 176px;
			position: relative;
			vertical-align: top;
			height: 22px;
			padding: 0 0 16px;
			td {
				position: relative;
				vertical-align: top;
				height: 22px;
				padding: 0 0 16px;
			}
			.padding {
				width: 29px;
			}
		}
		.hide {
			display: none;
		}
		.operateAddr {
			height: auto;
			.showAllAddr {
				width: 100px;
				@include fontSize($font-size-14);
				color: #d12147;
				border-bottom: 1px solid #fff;
				display: block;
				cursor: pointer;
			}
		}
	}
	.adrWrap {
		width: 342px;
		height: 158px;
		border: 1px solid #eee;
		position: relative;
		&.wrapChecked {
			border: 1px solid #e31436;
		}
	}
	.adrLabel {
		position: relative;
		width: 338px;
		height: 154px;
		border: 2px solid #fff;
		margin-right: 15px;
		cursor: pointer;
		&:hover {
			border-color: #f7f7f7;
			background: #f7f7f7;
		}
		&:hover .opSpan {
			display: block;
		}
		&.checked {
			border: 2px solid #e31436;
			// background: #fffbee url(./../../assets/order/orderConfirmImgs.png)
			//   no-repeat 308px 124px;
		}
		span {
			display: inline-block;
			margin: 0 auto;
			width: 300px;
			text-align: left;
			margin: 0 0 0 18px;
			padding-top: 3px;
			word-break: break-all;
		}
		.opSpan {
			position: absolute;
			left: 0;
			bottom: 7px;
			display: none;
			a:hover {
				text-decoration: underline;
				color: red;
			}
			.mod {
				color: #666;
			}
			.del {
				color: #666;
				margin-left: 25px;
			}
		}
	}
	.receiver {
		height: 35px;
		line-height: 35px;
		border-bottom: 1px solid #eee;
		font-weight: bold;
		strong {
			@include fontSize($font-size-14);
			float: left;
		}
		b {
			float: right;
			@include fontSize($font-size-12);
			color: #666;
			font-weight: normal;
			zoom: 1;
		}
	}
	.addressText {
		display: block;
		position: relative;
		line-height: 22px;
		color: #333;
		word-break: break-all;
		b {
			font-weight: normal;
		}
	}
	.orderwrap {
		min-height: 300px;
		* {
			box-sizing: initial;
		}
	}
	.m-goodstbl {
		.img {
			width: 100px;
			height: auto;
			padding: 10px;
			display: block;
			//min-height: 80px;
		}
		.thead {
			// margin: 0 20px;
			overflow: hidden;
			span {
				height: 33px;
				line-height: 33px;
				color: #999;
				@include fontSize($font-size-14);
				float: left;
			}
			.col1 {
				width: 37.4%;
				text-align: left;
			}
			.col2 {
				width: 22.4%;
				text-align: right;
			}
			.col3 {
				width: 19%;
				text-align: center;
			}
			.col4,
			.col6 {
				width: 5.5%;
				text-align: center;
			}
			.col5 {
				text-align: right;
				width: 14.5%;
				// padding-right: 2.5%;
			}
		}
		.m-warebox {
			border: 1px solid #e8e8e8;
			border-top: 0;
			margin-bottom: 20px;

			.packinfo {
				padding: 10px 20px;
				@include fontSize($font-size-14);
				box-sizing: initial;
				//padding: 10px 20px;
				overflow: hidden;
				line-height: 20px;
				border-bottom: 1px solid #eaeaea;
				border-top: 1px solid #eaeaea;
				em {
					font-weight: bold;
					font-style: normal;
					padding-left: 5px;
				}
				.taxfee {
					float: right;
					position: relative;
					.arr {
						position: absolute;
						right: 50px;
						top: 27px;
						border: 1px solid #999;
						width: 6px;
						height: 6px;
						margin-left: 5px;
						border-color: transparent transparent #ddd #ddd;
						-webkit-transform: rotate(135deg);
						-moz-transform: rotate(135deg);
						-ms-transform: rotate(135deg);
						-o-transform: rotate(135deg);
						transform: rotate(135deg);
						background-color: #fff;
					}
				}
			}
			.m-goodstbl {
				width: 100%;
				.tbody {
					@include fontSize($font-size-14);
					color: #666;

					.col {
						padding: 14px 0 7px;
						float: left;
						text-align: center;
					}
					.col0 {
						width: 18.6%;
						//text-align: left;
					}
					.col1 {
						text-align: left;
						display: flex;
						flex-direction: row;
					}
					.col2,
					.col3,
					.col4,
					.col5,
					.col6 {
						width: 12.4%;
						text-align: center;
					}
					.col5 {
						padding-right: 20px;
					}
				}
				.ttwrap {
					// float: left;
					// margin-left: 0px;
					// color: #666;
					// width: 200px;
					// padding-right: 60px;
					position: relative;
					color: #666;
					width: 70%;
					display: inline-block;
				}
				.returninfo {
					padding-top: 2px;
					img {
						width: 20px;
						height: 20px;
						margin-right: 5px;
					}
					span {
						vertical-align: text-bottom;
						color: $theme-color;
					}
				}
				.name {
					max-width: 280px;
				}
				.skuline {
					white-space: nowrap;
					text-overflow: ellipsis;
					-o-text-overflow: ellipsis;
					overflow: hidden;
					color: #999;
				}
				.product_detail_footer {
					display: none;
					.product_price {
						flex: 4;
						span {
							font-family: "Helvetica Neue", Tahoma, Arial;
						}
						span:nth-of-type(1) {
							font-size: 0.5rem;
							// color: #f60;
							margin-right: 0.05rem;
						}
						span:nth-of-type(2) {
							font-size: 0.6rem;
							// color: #f60;
							// font-weight: bold;
							margin-right: 0.3rem;
						}
						span:nth-of-type(3) {
							font-size: 0.5rem;
							// color: #666;
						}
					}
					.product_price1 {
						margin-right: 0.4rem;
						//flex: 3;
						font-size: 0.7rem;
						//color: #f60;

						span:nth-of-type(1) {
							font-size: 0.3rem;
							// color: #f60;
						}
						span:nth-of-type(2) {
							font-size: 0.3rem;
							//color: #f60;
						}
						span:nth-of-type(3) {
							margin-left: 0.3rem;
							font-size: 0.5rem;
							//color: black;
						}
						span:nth-of-type(4) {
							margin-left: 1.44rem;
							display: block;
							font-size: 0.7rem;
							//color: black;
						}
					}
				}

				.amountcol {
					text-align: right;
					margin-right: 30px;
					em {
						font-weight: bold;
						@include fontSize($font-size-14);
						font-style: normal;
					}
				}
				.goods-end {
					height: 1px;
					color: #dcdcdc;
					width: 100%;
				}
			}
		}
	}
	.order-summary {
		overflow: hidden;
		.statistic {
			// width: 300px;
			margin-bottom: 10px;
			margin-right: 20px;
			float: right;
			@include fontSize($font-size-15);
			.list {
				height: 24px;
				line-height: 40px;
				// overflow: hidden;
				margin-bottom: 5px;
				zoom: 1;
			}
			em {
				color: #e4393c;
				font-style: normal;
			}
			span {
				width: 400px;
				margin-right: 20px;
				float: left;
				text-align: right;
			}
			.price {
				color: #333;
				float: left;
				width: 150px;
				text-align: right;
				font-family: verdana;
			}
			.add_x {
				text-decoration: line-through;
			}
			.move_x {
				text-decoration: none;
			}
			.mdeliveryFemv {
				display: flex;
				position: relative;
				top: -10px;
				left: 0px;
				text-align: center;
				display: inline-block;
				div {
					font-size: 0.1rem;
					//height: 20px;
					//line-height: 15px;
					padding: 2px;
					border: 1px solid #666;
					border-radius: 10px;
					//margin-right: .1rem;
					transform: scale(1);
				}
				p {
					white-space: nowrap;
					line-height: initial;
					//line-height: 20px;
				}
			}
		}
	}
	.trade-foot {
		font-family: "Microsoft YaHei", SimSun, verdana;
		.trade-foot-detail-com {
			@include fontSize($font-size-15);
			padding: 15px 10px 15px 0;
			line-height: 20px;
			text-align: right;
			border-top: 1px solid #e6e6e6;
			color: #999;
			background-color: #f4f4f4;
			.fc-price-info {
				margin-right: 10px;
				line-height: 25px;
				.price-tit {
					color: #666;
				}
				.price-num {
					color: $theme-color;
					font-family: Verdana;
					font-weight: 700;
					@include fontSize($font-size-18);
					min-width: 122px;
					float: right;
					text-align: right;
				}
			}
			.fc-consignee-info {
				margin-right: 10px;
				line-height: 25px;
				.mr20 {
					// margin-right: 20px;
				}
				.edit {
					color: blue;
					cursor: pointer;
				}
			}
		}
	}
	.foot-button {
		height: 100%;
		margin-bottom: 8px;
		button {
			font-family: arial, "Microsoft YaHei";
			float: right;
			@include fontSize($font-size-15);
			font-weight: bold;
			margin: 8px 10px 0 0;
			width: 165px;
			height: 100%;
			margin-bottom: 5px;
			b {
				@include fontSize($font-size-13);
				display: block;
			}
		}
	}
}
.promote {
	background: url(../../../assets/order/address_bottom.png) left top repeat-x;
	background-size: auto 4px;
	padding-top: 10px;
	clear: both;
	.promote-tag {
		color: rgb(255, 70, 29);
		display: inline-block;
		font-weight: 500;
		line-height: 8.2px;
		padding: 5px;
		margin-left: 0px;
		border: 1px solid rgb(255, 70, 29);
		border-radius: 7.03px;
		margin-right: 2.34px;
	}
}
.tbody {
	width: 100%;
}
.td-right {
	flex: 2;
	align-self: center;
}
.main-bh {
	.tip {
		@include fontSize($font-size-13);
		margin-bottom: 10px;
		color: #31384a;
	}
	.highlight {
		animation: myfirst 2s;
		animation-iteration-count: infinite;
		-webkit-animation-iteration-count: infinite; /* Safari 和 Chrome */
		color: red;
	}

	@keyframes myfirst {
		0% {
			color: #ea1414;
		}
		25% {
			color: #31384a;
		}
		50% {
			color: #ea1414;
		}
		75% {
			color: #31384a;
		}
		100% {
			color: #ea1414;
		}
	}
}
@media (max-width: 768px){
	.mainWrap {
		width: 95%;
		margin-top: 10px;
		.m-goodstbl .img {
			width: 2rem;
			min-height: 2rem;
		}
		.foot-button {
			margin-top: 8px;
			button {
				width: 100%;
				margin: 0;
				margin-bottom: 8px;
				font-size: 0.5rem;
			}
		}
		.u-mntlt {
			border-bottom: none;
		}
	}

	.no_mobile {
		display: none;
	}
	.m-goodstbl .m-warebox .packinfo .taxfee {
		margin-top: 10px;
	}
	.mainWrap .m-goodstbl .m-warebox .m-goodstbl .tbody .col1 {
		width: 100%;
		padding: 10px 0px;
	}
	table.tbody {
		margin: 0px 0px 0px 0px;
	}
	.mainWrap .m-goodstbl .m-warebox .m-goodstbl .product_detail_footer {
		display: flex;
	}
	.promote {
		background-size: auto 2px;
	}
	.mainWrap .trade-foot .trade-foot-detail-com {
		text-align: left;
		.fc-price-info {
			margin-right: 0;
		}
		.fc-consignee-info span {
			display: inline-block;
		}
	}

	.mainWrap .order-summary {
		.statistic {
			margin-right: 0;
			float: none;
			font-size: 0.5rem;
			span {
				width: initial;
				//float: none;
			}
			.price {
				float: right;
			}
		}
	}
	.mainWrap .m-goodstbl .m-warebox .m-goodstbl .tbody {
		font-size: 0.5rem;
	}
	.mainWrap  .u-mntlt strong{
		font-size: 0.5rem;
	}
	.mainWrap .m-goodstbl .m-warebox .packinfo{
		font-size: 0.5rem;
		padding: 10px 10px;
	}
	.mainWrap .trade-foot .trade-foot-detail-com{
		font-size: 0.5rem;
	}
	.mainWrap .trade-foot .trade-foot-detail-com .fc-price-info .price-num{
		font-size: 0.5rem;
	}

}
</style>